<template>
  <div class="content-area ajustaElColorDeFondo">
    <h1>La página que intentas acceder no fue encontrada</h1>
    <br />
    <h3>
      <strong>Mensaje</strong>
      <br />
      Verifique que el link ingresado o seleccionado este escrito correctamente e inténtelo de nuevo.
    </h3>
  </div>
</template>

<script>
  export default {
    props: {
      mensaje: String
    }
  }
</script>

<style scoped>
  .ajustaElColorDeFondo {
    background-color: #1f1f21 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Comunes/Error404.vue